import ReactLoadingSkeleton from 'react-loading-skeleton';

import { FiltersBarSkeleton, GraphSkeleton, KPISkeleton, MatchingResolutionButtonsSkeleton } from './';

import type { SkeletonProps } from './Skeleton.types';
import { TabsSkeleton } from './tabs-skeleton/TabsSkeleton';

export const Skeleton = ({ preset = 'custom', ...props }: SkeletonProps) => {
  switch (preset) {
    case 'filters-bar':
      return FiltersBarSkeleton({ ...props });
    case 'kpi':
      return KPISkeleton({ ...props });
    case 'graph':
      return GraphSkeleton({ ...props });
    case 'matching-resolution-buttons':
      return MatchingResolutionButtonsSkeleton({ ...props });
    case 'tabs':
      return TabsSkeleton({ ...props });
    // 'line' and 'custom'
    default:
      return <ReactLoadingSkeleton containerTestId="skeleton-line" {...props} borderRadius={1} />;
  }
};
